<template lang="pug">
  .body.garbage-house-container-table.body-flex
    .table-choose-panel.body-flex
      .toolbar-table
        e-select-list(
          :options="selectListOptions"
          v-model="operationType"
        )
        .toolbar__center(v-if="needContainerVolume>0")
          span.semibold.red-color Объем поступающих отходов превышает общий объем контейнерной площадки, рекомендуется создать дополнительную контейнерную площадку или контейнеры на {{needContainerVolume}} куб.м

        .toolbar.toolbar--modal.toolbar_no-padding.toolbar_margin-bottom
          .toolbar__line.line.toolbar__right
            .parameters.display-flex(style="gap:10px")
              e-year-selector(year="year" @onSelectItem="onSelectYear")
              .actions-panel.view-panel.view-panel_divide
                e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(@click="addNewRowToTable" label="Добавить" )
      e-table-editable(
        v-if="operationType === '1'"
        ref="garbage"
        :attributes="garbageAttr"
        :dataUrl="garbageDataUrl"
        :postUrl="garbagePostUrl"
        :patchUrl="garbagePatchUrl"
        :deleteUrl="garbageDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        :onlyOneAdd="false"
        :summaryColumns="summaryColumns"
        :onDoubleClick="onDoubleClickToGarbage"
        @afterCreateRow="afterCreateGarbageRow"
        @editEvent="afterEditGarbageRow"
        @afterDeleteRow="afterDeleteRow"
      )

      e-table-editable(
        v-if="operationType === '2'"
        ref="house"
        :attributes="houseAttr"
        :dataUrl="houseDataUrl"
        :postUrl="housePostUrl"
        :patchUrl="housePatchUrl"
        :deleteUrl="houseDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
      )

      e-modal(v-if="showGarbageModal"
        @close="showGarbageModal = false"
        @confirm="saveGarbageList()"
        title="Выбор отходообразователей"
      )
        slot
          e-table-checked-list(
            @checkedChange="garbageListUpdate($event)"
            :endpoint="endpointGarbageList"
            :earlyCheckedItems="earlyCheckedGarbage"
            :showPaginate="true"
          )
            template(slot="tableLeftFilterPanel")
              button.reset-btn.button(@click='onShowGarbageChoose') Добавить отходообразователя

        template(slot="footer")
          .search-result
            span Выбрано {{checkedGarbageLen}} объектов
          .footer__buttons
            button.reset-btn.button.button_no-border.button_color.modal__button(
              type="button"
              @click="closeGarbageModal()"
            ) Отмена
            button.reset-btn.button.button_no-border.button_color.modal__button(
              type="button"
              @click="saveGarbageList()"
            ) Сохранить
      e-modal(
        v-if="showGarbageChooseModal"
        @close="showGarbageChooseModal = false"
        @confirm="confirmChooseModal"
        title="Выбрать тип отходообразователя"
        saveBtnLabel="Подтвердить"
        modalClass="fixed-overlay fixed-overlay__modal garbage-choose-modal"
      )
        .select-garbage
          select.select(v-model="selectedType")
            option(v-for="type in garbageTypes" :value="type.id" :key="'type-'+type.id") {{type.name}}
</template>

<script>
import { msnOffline } from '@/api/api-offline-endpoints'
import { garbage, housing, msn } from '@/api/api-endpoints'
import url from '@/utils/url'
import year from '@/utils/year'

const Model = (operationType) => {
  return {
    addressName: '',
    name: '',
    type: JSON.parse(JSON.stringify(operationType)),
  }
}
const garbageTypes = [
  {
    id: 'organization',
    name: 'Отходообразователи',
  },
  {
    id: 'mkd',
    name: 'Многоквартирные дома',
  },
  {
    id: 'individual_area',
    name: 'Индивидуальные домовладения',
  },
]
export default {
  name: 'garbage-house-container-table',
  props: {
    id: null,
    tabView: null,
  },
  data() {
    return {
      showGarbageModal: false,
      showGarbageChooseModal: false,
      checkedGarbageLen: 0,
      checkedGarbage: [],
      garbageModels: {},
      operationType: null,
      search: '',
      searchModel: '',
      needContainerVolume: null,
      year: year.getCurrentYear(),
      garbageTypes: garbageTypes,
      selectedType: 'organization',
    }
  },
  computed: {
    summaryColumns() {
      return ['volume']
    },
    selectListOptions() {
      return [
        {
          id: '1',
          name: 'Отходообразователи',
        },
      ]
    },
    tableInOnlineMode() {
      return this.$route.params.id
    },
    enableOnAdd() {
      return []
    },
    garbageAttr() {
      return {
        name: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          required: true,
          placeholder: 'Начните вводить название отходообразователя',
          suggestion: {
            options: [],
            onSelect: this.onSelectGarbage,
            suggestionEndpoint: this.suggestionGarbageEndpoint,
            transformSuggestions: this.transformSuggestionsGarbage,
          },
        },
        addressName: {
          label: 'Местоположение',
          required: true,
          placeholder: 'Выберите отходообразователя сначала',
          disabled: true,
          validationRulePattern: '(\\.*)',
        },
        volume: {
          label: 'Объём поступающих отходов, куб.м',
          required: true,
          validationRulePattern: '(\\.*)',
        },
        approved: {
          label: 'Утверждено',
          validationRulePattern: '(\\.*)',
          select: {
            options: [
              { id: true, name: 'Да' },
              { id: false, name: 'Нет' },
            ],
          },
          transform: (model) => (model.approved ? 'Да' : 'Нет'),
        },
      }
    },
    houseAttr() {
      return {
        name: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          required: true,
          placeholder: 'Начните вводить адрес дома',
          suggestion: {
            options: [],
            onSelect: this.onSelectHouse,
            suggestionEndpoint: this.suggestionHouseEndpoint,
            transformSuggestions: this.transformSuggestionsHouse,
          },
        },
        addressName: {
          label: 'Адрес',
          required: true,
          placeholder: 'Выберите до сначала',
          disabled: true,
          validationRulePattern: '(\\.*)',
        },
      }
    },
    garbageDataUrl() {
      if (this.tableInOnlineMode) {
        let routeQuery = {
          query: {
            msn_id: this.id,
            year: this.year,
          },
        }
        if (this.search) {
          routeQuery.query.q = this.search
        }
        return msn.garbageHouseOperation(routeQuery)
      }
      // if new record, offline save
      return msnOffline.garbageHouseContainerTable(
        this.$route.name,
        this.operationType
      )
    },
    houseDataUrl() {
      if (this.tableInOnlineMode) {
        let routeQuery = {
          query: {
            sourceId: this.id,
            type: this.operationType,
          },
        }
        if (this.search) {
          routeQuery.query.q = this.search
        }
        return msn.garbageHouseOperation(routeQuery)
      }
      // if new record, offline save
      return msnOffline.garbageHouseContainerTable(
        this.$route.name,
        this.operationType
      )
    },
    garbageItems() {
      return this.$store.getters.readUrlEndpoint(this.garbageDataUrl)
    },
    earlyCheckedGarbage() {
      let checked = []
      if (this.garbageItems && this.garbageItems.data) {
        this.garbageItems.data.forEach((v) => {
          if (v.garbage_source_id) {
            checked.push(v.garbage_source_id)
          } else if (v.msnGarbageSources) {
            v.msnGarbageSources.forEach((gs) => {
              checked.push(gs.garbage_source_id)
            })
          }
        })
      }
      return { default: checked }
    },
  },
  methods: {
    afterCreateGarbageRow({ model }) {
      model.year = this.year
      if (this.$route.params.garbage) {
        model.garbage_source_id = this.$route.params.garbage.garbage_source_id
        model.msn_id = this.id
        model.addressName = this.$route.params.garbage.addressName
        model.name = this.$route.params.garbage.name
      }
      this.$refs.garbage.saveRow(model, -1, false)
    },
    endpointGarbageList(ctx, query = { 'per-page': 50 }) {
      let route = { query }
      if (ctx.q) {
        route.query.q = ctx.q
      }
      if (ctx.paginateObj) {
        route.query = Object.assign(route.query, ctx.paginateObj)
      }
      if (ctx.currentSort) {
        route.query.sort = ctx.currentSort
      }

      return {
        url: garbage.garbages(route),
        fields: {
          name: {
            label: 'Название',
          },
          address: {
            label: 'Местоположение',
          },
        },
      }
    },
    garbageListUpdate($event) {
      let { checked, checkedLen, checkedModels } = $event
      this.checkedGarbageLen = checkedLen
      this.checkedGarbage = checked?.default
      this.garbageModels = Object.assign(
        {},
        this.garbageModels,
        checkedModels.default
      )
    },
    saveGarbageList() {
      try {
        let earlyCheckedGarbage = this.earlyCheckedGarbage.default
        this.checkedGarbage.forEach((id) => {
          // check for dublicates
          if (earlyCheckedGarbage.indexOf(id) === -1) {
            let model = new Model(this.operationType)
            if (this.garbageModels.hasOwnProperty(id)) {
              model.garbage_source_id = id
              model.msn_id = this.id
              model.name = this.$options.filters.stripHtml(
                this.garbageModels[id].name
              )
              // set space for disable reuqired error and disable palcholder
              model.addressName = this.garbageModels[id].address || ' '
              this.$refs.garbage.createRow(model)
            } else {
              throw new Error(
                'Не удалось найти информацию об отходобразователе'
              )
            }
          }
        })
      } catch (e) {
        this.$e.errorBox(e)
      }
      this.closeGarbageModal()
    },
    afterFetchData(ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i]) {
          data.data[i].addressName =
            data.data[i].address?.value ||
            data.data[i].address?.source ||
            data.data[i].fact_address ||
            data.data[i].garbage_source?.fact_address
          data.data[i].name = data.data[i].garbage_source?.name
        } else {
          data.data[i].addressName = ''
        }
      }
      this.needContainerVolume = data._meta.needContainerVolume.toFixed(2)
      return data
    },
    onSelectYear(year) {
      this.year = year
    },

    onSelectHouse(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.name = copy.name
        model.addressName = copy.address
        model.house_id = copy.id
      } else {
        model.name = ''
        model.house_id = ''
      }
    },
    suggestionHouseEndpoint(ctx, q) {
      return housing.houses({ query: { q, 'per-page': 50 } })
    },
    transformSuggestionsHouse(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          id: data[i].id,
          address: data[i].name,
        })
      }
      return options
    },
    onSelectGarbage(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.name = this.$options.filters.stripHtml(copy.name)
        model.garbage_id = copy.id
        model.addressName = copy.address || ' '
      } else {
        model.name = ''
        model.garbage_id = ''
        model.addressName = ''
      }
    },
    suggestionGarbageEndpoint(ctx, q) {
      return garbage.garbages({
        query: {
          q,
          'per-page': 50,
        },
      })
    },
    transformSuggestionsGarbage(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          id: data[i].id,
          address: data[i].address,
        })
      }
      return options
    },
    housePostUrl() {
      return null
    },
    housePatchUrl() {
      return null
    },
    houseDeleteUrl() {
      return null
    },
    garbagePostUrl() {
      return msn.garbageHouseOperationPost()
    },
    garbagePatchUrl(context, model) {
      return msn.garbageHouseOperationPath(model.id)
    },
    garbageDeleteUrl(context, model) {
      return msn.garbageHouseOperationDelete(model.id)
    },
    closeGarbageModal() {
      this.showGarbageModal = false
      this.checkedGarbageLen = 0
    },
    openGarbageModal() {
      this.showGarbageModal = true
    },
    addNewRowToTable() {
      if (this.operationType === '1') {
        this.openGarbageModal()
      } else if (this.operationType === '2') {
        this.$refs.house.createRow(new Model(this.operationType))
      }
    },
    afterEditGarbageRow() {
      this.$refs.garbage.fetchData()
    },
    afterDeleteRow() {
      this.$refs.garbage.fetchData()
    },
    onDoubleClickToGarbage(value) {
      this.$router.push({
        name: `garbage.${value.garbage_source.type_code}.update`,
        params: { id: value.garbage_source?.id || value.garbage_source_id },
        query: {
          prevRoute: url.getRoute(this.$route, true),
        },
      })
    },
    onShowGarbageChoose() {
      this.showGarbageModal = false
      this.showGarbageChooseModal = true
    },
    confirmChooseModal() {
      this.$router.push({
        name: `garbage.${this.selectedType}.create`,
        query: {
          prevRoute: url.getRoute(this.$route, true),
        },
      })
    },
    checkGarbageParams() {
      if (this.$route.params.garbage) {
        setTimeout(() => {
          this.$refs.garbage.createRow({ type: 1, msn_id: this.id, ...garbage })
        }, 1000)
      }
    },
  },
  mounted() {
    this.checkGarbageParams()
  },
}
</script>
